import React from 'react';
import styled from '@emotion/styled';
import tasteImage from '../../images/taste.jpg';
import Modal from '../Modal';

import { StaticQuery, graphql } from 'gatsby';
import kebabCase from "lodash/kebabCase";

import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import CategoryIcon from '@material-ui/icons/Category';
import ColorLensSharpIcon from '@material-ui/icons/ColorLensSharp';

const TitleBox = styled.div`
padding:20px;
   h2 {
       margin-top:0;
       margin-bottom:20px;
       text-decoration:none;
       font-weight:600;
       color:#00897b;
   }
   h5 {
       color:red;
       text-decoration:underline;
   }
`;

const ThemeSection = styled.section`
padding-bottom:20px;
background-color:#fffbf0;
img {
padding-top:30px;
max-height:280px;
}
h3 {
color:green;
text-decoration:underline;
}
@media(min-width:${props => props.theme.breakpoints.sm}) {
display: -webkit-flex;
display: flex;
-webkit-justify-content: center;
justify-content: space-evenly;
-webkit-align-items: stretch;
align-items: stretch;
}
`;

const StyledChip = styled(Chip)`
   margin:0.5rem;
`;

const SelectTheme = () => (
    <ThemeSection>
    <img src={tasteImage} alt="taste image"/>
    <TitleBox>
            <h2><ColorLensSharpIcon color="primary"/>&nbsp;选择口味&nbsp;<ColorLensSharpIcon color="secondary"/></h2>
            <p>有好多种口味</p>
            <p>选择您喜欢的口味</p>
            <p>找一找口味</p>
            <Modal type="normal" title="选择口味" style={{backgroundColor:"#009688",color:"white"}} icon={<CategoryIcon />}>
                <StaticQuery 
            query={graphql`
                    query {
                        allContentfulFood {
                            group(field: tags___tag) {
                              fieldValue
                              totalCount
                            }
                          }
                    }
                    `}
            render={
                data => (
                data.allContentfulFood.group.map(tag => (
                <StyledChip
                icon={<DoneIcon />}
                label={`${tag.fieldValue}(x${tag.totalCount})`} 
                component='a' 
                href={`/tags/${kebabCase(tag.fieldValue)}/`} 
                />
                
                ))
                )}/>
            </Modal>
        </TitleBox>
    </ThemeSection>
)

export default SelectTheme;